import { NotificationErrorCode } from '../notifications/notification.constants';

const DEFAULT_ERROR_MESSAGE = 'Sorry, an error occurred. Please try again later.';

export default function parseServerError(error?: Record<string, any>) {
  if (!error) return DEFAULT_ERROR_MESSAGE;

  const notification = error.data ?? error;

  switch (notification.code) {
    case NotificationErrorCode.VALIDATION_ERROR:
      return 'The data provided is invalid. Please check and try again.';
    case NotificationErrorCode.NOT_AUTHENTICATED:
      return notification.message;
    case NotificationErrorCode.INCORRECT_LOGIN_DETAILS:
      return 'The login details are incorrect. Please try again.';
    case NotificationErrorCode.INCORRECT_OLD_PASSWORD:
      return 'The old password you entered is incorrect';
    case NotificationErrorCode.USER_ALREADY_EXISTS:
      return !notification.customMsg ? 'There is already a user with that email' : notification.customMsg;
    case NotificationErrorCode.PASS_ALREADY_EXISTS:
      return !notification.customMsg ? 'Guest already signed in' : notification.customMsg;
    case NotificationErrorCode.VERIFY_TOKEN_INVALID:
      return 'The Verification pin you entered is incorrect. Please try again.';
    case NotificationErrorCode.FORBIDDEN:
      return 'This action is not allowed, please contact administrator.';
    case NotificationErrorCode.INTEGRATION_OAUTH_FAILED_ERROR:
      return 'Integration Authentication failed, please contact administrator';
    case NotificationErrorCode.INTERNAL_SERVER_ERROR:
      return 'Server Error occurred';
    case NotificationErrorCode.PERMISSION_ALREADY_EXISTS:
      return 'This team member already has these permissions';
    case NotificationErrorCode.SITE_NAME_NOT_IDENTICAL:
      return 'Site names created under the same team must not be identical.';
    case NotificationErrorCode.SITE_CHECKIN_DISABLED:
      return 'Check-ins at this site are currently deactivated. Contact Sine Support for assistance.';
    case NotificationErrorCode.INVALID_PASS_STATUS:
      return `${error.customMsg} - this pass has already been actioned`;
    case NotificationErrorCode.USER_VERIFICATION_REQUIRED:
      return 'Your account is not verified. Please verify and try again.';
    case NotificationErrorCode.EMAIL_INVALID:
      return 'This email cannot be used';
    default:
      // eslint-disable-next-line no-console
      console.warn('Unhandled error:', error);
      return notification.customMsg || error.customMsg || notification.message || DEFAULT_ERROR_MESSAGE;
  }
}
